import React, { useEffect, useState } from 'react'
import StyledSelect from '../../../generic/StyledSelect'
import { backendPatchWithoutRefresh } from '../../../../helpers/callBackend'
import checkFlag from '../../../../helpers/featureFlags'

const TeamRoleSelect = ({ ucsId, currentUcsArray, setUcsArray }) => {
  const [userRole, setUserRole] = useState('member')
  const [loading, setLoading] = useState(true)

  const roles = [
    {
      display_text: 'Member',
      value: 'member',
    },
    {
      display_text: 'Admin',
      value: 'admin',
    },
  ]

  if (checkFlag('dashboardEditor')) {
    roles.push({
      display_text: 'Dashboard Editor',
      value: 'editor',
    })
  }

  const rolePermissionsMap = {
    member: {
      is_admin: false,
      dashboard_editor: false,
    },
    admin: {
      is_admin: true,
      dashboard_editor: true,
    },
    editor: {
      is_admin: false,
      dashboard_editor: true,
    },
  }

  const updateUcsObject = async (event) => {
    const roleSettings = rolePermissionsMap[event.target.value]

    let data = {
      id: ucsId,
      settings: {
        ...roleSettings,
      },
    }

    const ucsObject = await backendPatchWithoutRefresh('/api/landlord/permissions/', data)

    if (ucsObject.status == 200) {
      let newUcsObjects = [...currentUcsArray]
      const patchedIdx = currentUcsArray.findIndex((ucsObject) => {
        if (ucsObject.id == ucsId) {
          return ucsObject
        }
      })
      newUcsObjects.splice(patchedIdx, 1, ucsObject.data.data)
      setUcsArray(newUcsObjects)
    }
  }

  useEffect(() => {
    setLoading(true)
    const rowUcs = currentUcsArray.find((ucsObject) => ucsObject.id == ucsId)
    if (!rowUcs) {
      return
    }
    if (rowUcs.is_admin) {
      setUserRole('admin')
      setLoading(false)
    } else if (rowUcs.dashboard_editor && checkFlag('dashboardEditor')) {
      setUserRole('editor')
      setLoading(false)
    } else {
      setUserRole('member')
      setLoading(false)
    }
  }, [currentUcsArray])

  return (
    <StyledSelect
      label=''
      formWidth='100%'
      formHeight='50%'
      value={userRole}
      disabled={loading}
      onChange={(event) => {
        updateUcsObject(event)
      }}
      items={roles}
    />
  )
}

export default TeamRoleSelect
